"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrandedAvatar = void 0;
var _react = _interopRequireDefault(require("react"));
var _BrandedAvatar = require("./BrandedAvatar.styled");
var _Avatar = require("./Avatar");
var _propTypes = require("prop-types");
var _Dimensions = require("../../utils/Dimensions");
var _SceneLayouts = require("../../constants/SceneLayouts");
var avatarBackgroundColor = 'rgb(51, 54, 73)';

/* Prop types
* user: object
* height: in px
* width: in px
* isStage: boolean shows if cameraOff component is on stage
* */
var BrandedAvatar = exports.BrandedAvatar = function BrandedAvatar(props) {
  var user = props.user,
    height = props.height,
    width = props.width,
    isStage = props.isStage;
  var brandedAvatarDim;
  var middleCircleDim;
  var avatarDim;
  var avatarInitialsFontSize;
  var minOfHeightWidth = Math.min(parseInt(height), parseInt(width));
  if (isStage) {
    var STAGE_SCALE_RATIO = 1 / ((0, _Dimensions.getElementWidth)('#scaledStageContainer') / _SceneLayouts.SCENE_WIDTH);
    brandedAvatarDim = Math.min(parseInt(minOfHeightWidth) / STAGE_SCALE_RATIO * 60 / 100, 300);
    middleCircleDim = parseInt(brandedAvatarDim) * 90 / 100 * STAGE_SCALE_RATIO;
    middleCircleDim = parseFloat(middleCircleDim.toFixed(2));
    avatarDim = parseInt(brandedAvatarDim) * 80 / 100 * STAGE_SCALE_RATIO;
    avatarDim = parseFloat(avatarDim.toFixed(2));
    avatarInitialsFontSize = parseInt(brandedAvatarDim) * 23 / 100 * STAGE_SCALE_RATIO;
    avatarInitialsFontSize = parseFloat(avatarInitialsFontSize.toFixed(2));
    brandedAvatarDim = brandedAvatarDim * STAGE_SCALE_RATIO;
    brandedAvatarDim = parseFloat(brandedAvatarDim.toFixed(2));
  } else {
    brandedAvatarDim = Math.min(parseInt(minOfHeightWidth) * 60 / 100, 300);
    middleCircleDim = parseInt(brandedAvatarDim) * 90 / 100;
    avatarDim = parseInt(brandedAvatarDim) * 80 / 100;
    avatarInitialsFontSize = parseInt(brandedAvatarDim) * 23 / 100;
  }
  return /*#__PURE__*/_react["default"].createElement(_BrandedAvatar.OuterCircle, {
    height: "".concat(brandedAvatarDim, "px"),
    width: "".concat(brandedAvatarDim, "px"),
    "data-testid": "branded-avatar-outer-circle"
  }, /*#__PURE__*/_react["default"].createElement(_BrandedAvatar.MiddleCircle, {
    height: "".concat(middleCircleDim, "px"),
    width: "".concat(middleCircleDim, "px"),
    "data-testid": "branded-avatar-middle-circle"
  }, /*#__PURE__*/_react["default"].createElement(_Avatar.Avatar, {
    user: user,
    height: "".concat(avatarDim, "px"),
    width: "".concat(avatarDim, "px"),
    backgroundColor: avatarBackgroundColor,
    initialsFontSize: "".concat(avatarInitialsFontSize, "px"),
    hideTooltip: true,
    showColor: true
  })));
};
BrandedAvatar.propTypes = {
  user: _propTypes.PropTypes.object.isRequired,
  height: _propTypes.PropTypes.number.isRequired,
  width: _propTypes.PropTypes.number.isRequired,
  isStage: _propTypes.PropTypes["boolean"]
};